module.exports = __webpack_public_path__ + "static/img/u70076.d17de10b.png";